(function () {
  'use strict';

  var CONFIG = {
    syncEnabled: true,
    giftIds: { trial: 53777928716653, applicator: 53777929011565, care: 53777929109869 },
    images: {
      trial: 'https://cdn.shopify.com/s/files/1/0911/2453/1565/files/olola-1day-trial-pair-gift.jpg?v=1787299690',
      applicator: 'https://cdn.shopify.com/s/files/1/0911/2453/1565/files/olola-applicator-set-gift.png?v=1787299699',
      care: 'https://cdn.shopify.com/s/files/1/0911/2453/1565/files/olola-lens-care-kit-gift.jpg?v=1787299706'
    }
  };
  var giftIdList = Object.keys(CONFIG.giftIds).map(function (key) { return CONFIG.giftIds[key]; });
  var busy = false;
  var timer;

  function isGift(item) {
    return giftIdList.indexOf(Number(item.variant_id || item.id)) !== -1 ||
      Boolean(item.properties && item.properties._essentials_gift === 'true');
  }

  function lensType(item) {
    var type = String(item.product_type || '').toLowerCase().replace(/\s+/g, '');
    if (type.indexOf('1month') !== -1 || type.indexOf('monthly') !== -1) return 'monthly';
    if (type.indexOf('1day') !== -1 || type.indexOf('oneday') !== -1 || type.indexOf('daily') !== -1) return '1day';
    return '';
  }

  function powersFor(items, kitType) {
    var relevant = items.filter(function (item) { return lensType(item) === kitType; });
    if (!relevant.length) return { left: '', right: '' };
    if (kitType === 'monthly') {
      var parts = String(relevant[0].variant_title || '').split('/').map(function (value) { return value.trim(); }).filter(Boolean);
      return { left: parts[0] || '', right: parts[1] || parts[0] || '' };
    }
    var powers = [];
    relevant.some(function (item) {
      var count = Math.max(1, Number(item.quantity) || 1);
      while (count-- > 0 && powers.length < 2) powers.push(String(item.variant_title || '').trim());
      return powers.length === 2;
    });
    return { left: powers[0] || '', right: powers[1] || powers[0] || '' };
  }

  function plan(cart) {
    var paidItems = cart.items.filter(function (item) { return !isGift(item); });
    var hasMonthly = paidItems.some(function (item) { return lensType(item) === 'monthly'; });
    var hasDay = paidItems.some(function (item) { return lensType(item) === '1day'; });
    if (!hasMonthly && !hasDay) return null;
    var kitType = hasMonthly ? 'monthly' : '1day';
    return {
      kitType: kitType,
      powers: powersFor(paidItems, kitType),
      desired: kitType === 'monthly' ? [CONFIG.giftIds.trial, CONFIG.giftIds.care] : [CONFIG.giftIds.trial, CONFIG.giftIds.applicator]
    };
  }

  function card(image, name, value) {
    return '<div class="olola-kit-card"><img src="' + image + '" alt="' + name + '">' +
      '<div class="olola-kit-card__details"><p class="olola-kit-card__name">' + name + '</p>' +
      '<p class="olola-kit-card__prices"><span class="olola-kit-card__price">' + value + '</span>' +
      '<span class="olola-kit-card__zero">$0.00</span><span class="olola-kit-card__included">INCLUDED</span></p></div></div>';
  }

  function render(cart) {
    var existing = document.querySelector('[data-olola-kit-panel]');
    var current = plan(cart);
    if (!current || !/\/cart(?:\/|$|\?)/.test(location.pathname + location.search)) {
      if (existing) existing.remove();
      return;
    }
    var isMonthly = current.kitType === 'monthly';
    var kitName = isMonthly ? 'Monthly Essentials Kit' : '1-Day Essentials Kit';
    var secondCard = isMonthly ? card(CONFIG.images.care, 'OLOLA Lens Care Kit', '$3.00') : card(CONFIG.images.applicator, 'OLOLA Applicator Set', '$3.00');
    var panel = existing || document.createElement('section');
    panel.className = 'olola-kit-panel';
    panel.setAttribute('data-olola-kit-panel', '');
    panel.innerHTML = '<p class="olola-kit-panel__eyebrow">Complimentary gift</p>' +
      '<h2 class="olola-kit-panel__title">' + kitName + '</h2>' +
      '<p class="olola-kit-panel__copy">Included automatically with eligible lenses in your order.</p>' +
      '<div class="olola-kit-panel__items">' + card(CONFIG.images.trial, 'OLOLA 1-Day Trial Pair', '$5.00') + secondCard + '</div>' +
      '<div class="olola-kit-panel__total"><span>Total kit value</span><span><s>$8.00</s><strong>$0.00 · INCLUDED</strong></span></div>' +
      '<p class="olola-kit-panel__note">One complimentary kit per order. Trial powers are matched to the lenses purchased.</p>';
    if (!existing) {
      var anchor = document.querySelector('form[action*="/cart"]') || document.querySelector('#MainContent') || document.querySelector('main');
      if (anchor) anchor.prepend(panel);
    }
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (response) { if (!response.ok) throw new Error('Cart update failed'); return response.json(); });
  }

  function sync(cart, current) {
    if (!CONFIG.syncEnabled || busy) return Promise.resolve(false);
    busy = true;
    var gifts = cart.items.filter(isGift);
    var desired = current ? current.desired : [];
    var removals = gifts.filter(function (item) { return desired.indexOf(Number(item.variant_id)) === -1 || Number(item.quantity) !== 1; });
    var chain = Promise.resolve();
    removals.forEach(function (item) { chain = chain.then(function () { return post('/cart/change.js', { id: item.key, quantity: 0 }); }); });
    var existingIds = gifts.filter(function (item) { return Number(item.quantity) === 1; }).map(function (item) { return Number(item.variant_id); });
    var additions = current ? desired.filter(function (id) { return existingIds.indexOf(id) === -1; }) : [];
    if (additions.length) {
      chain = chain.then(function () {
        return post('/cart/add.js', { items: additions.map(function (id) {
          return { id: id, quantity: 1, properties: {
            _essentials_gift: 'true', _kit_type: current.kitType,
            _power_left: current.powers.left, _power_right: current.powers.right
          } };
        }) });
      });
    }
    return chain.then(function () { return removals.length > 0 || additions.length > 0; }).finally(function () { busy = false; });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var current = plan(cart);
          render(cart);
          return sync(cart, current).then(function (changed) { if (changed) location.reload(); });
        })
        .catch(function (error) { console.warn('[OLOLA Essentials Kit]', error); });
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  window.OLOLA_EssentialsKit = { plan: plan, refresh: refresh, config: CONFIG };
})();
